module.exports = require('./readable').Transform



//////////////////
// WEBPACK FOOTER
// (webpack)/~/node-libs-browser/~/readable-stream/transform.js
// module id = 314
// module chunks = 0